<script>
import IconDots from "@/components/icons/green/IconGreenDots.vue";

export default {
  name: "DesktopMenuButton",
  components: {
    IconDots
  },
  props: {
    expanded: { type: Boolean, required: false, default: false }
  }
};
</script>

<template>
  <button
    class="desktop-menu"
    type="button"
    tabindex="0"
    data-toggle="dropdown"
    aria-haspopup="true"
    :aria-expanded="expanded"
  >
    <IconDots class="desktop-menu__icon" role="presentation" />
  </button>
</template>
